import React from 'react';
import {BrowserRouter as Router, Route} from "react-router-dom";
import {AuthProvider, PrivateRoute} from 'react-auth-kit';
import AvailabilityPageNew from "../Pages/AvailabilityPageNew";
import DealerAvailabilityPage from "../Pages/DealerAvailabilityPage";
import SelectRoomPage from "../Pages/SelectRoomPage";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../utils/theme";
import ReviewPage from "../Pages/ReviewPage";
import ActivitiesPage from "../Pages/ActivitiesPage";
import InformationPage from "../Pages/InformationPage";
import TermsAndConditionsPage from "../Pages/TermsAndConditionsPage";
import PaymentPage from "../Pages/PaymentPage";
import ConfirmationPage from "../Pages/ConfirmationPage";
import WaitListPage from "../Pages/WaitListPage";
import InquiryPage from "../Pages/InquiryPage";
import LoginPage from "../Pages/Auth/LoginPage";
import ForgotPasswordPage from "../Pages/Auth/ForgotPasswordPage";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import MyBookingsPage from "../Pages/Auth/MyBookingsPage";
import BookingPage from "../Pages/Auth/BookingPage";
import PersonalInformationPage from "../Pages/Auth/GuestInformation/PersonalInformationPage";
import MedicalInsurancePage from "../Pages/Auth/GuestInformation/MedicalInsurancePage";
import DivingPage from "../Pages/Auth/GuestInformation/DivingPage";
import ExtraPark from "../Pages/Auth/GuestInformation/ExtraPark";
import HoldPage from "../Pages/HoldPage";
import ExtraActivityPage from "../Pages/Auth/GuestInformation/ExtraActivityPage";
import ExtraActivityOrder from "../Pages/Auth/GuestInformation/ExtraActivityOrder";
import DashboardPaymentPage from "../Pages/Auth/DashboardPaymentPage";
import CustomRoute from "./CustomRoute";
import ChangePasswordPage from "../Pages/Auth/ChangePasswordPage";
import UpgradeBookingPage from "../Pages/UpgradeBookingPage";
import { isDealerSite } from "../utils/utils";
import GuestAccessPage from "../Pages/Auth/GuestInformation/GuestAccessPage";
import AnonymousPaymentPage from "../Pages/AnonymousPaymentPage";
import AnonymousPaymentPageNew from "../Pages/AnonymousPaymentPageNew";
import AnonymousTermsPage from "../Pages/AnonymousTermsPage";
import CharterPage from '../Pages/Dealers/CharterPage';

import { GoogleOAuthProvider } from '@react-oauth/google';
import LoginPageTest from "../Pages/Auth/LoginPageTest";
import GuestAccommodationPage from "../Pages/Auth/GuestInformation/GuestAccommodation";
import DashboardTermsAndConditionsPage from "../Pages/Auth/DashboardTermsAndConditionsPage";
import ListReviews from "../Pages/ListReviews";
import ReviewsPage from "../Pages/ReviewsPage";
import GetWidgetApiKey from "../Pages/Dealers/GetWidgetApiKey";

// payment new page for test
import PaymentPageNew from "../Pages/PaymentPageNew";
import DashboardPaymentPageNew from "../Pages/Auth/DashboardPaymentPageNew";
import BasicAuth from "../Pages/Auth/BasicAuth";
import DayTripBookingPage from "../Pages/Dealers/DayTripBookingPage";
import DayTripListPage from "../Pages/Dealers/DayTripListPage";
import DayTripReviewPage from "../Pages/Dealers/DayTripReviewPage";
import DayTripsPaymentPage from "../Pages/Dealers/DayTripPaymentPage";
import DayTripConfirmationPage from "../Pages/Dealers/DayTripConfirmationPage";
import DayTripInquiryPage from "../Pages/Dealers/DayTripsInquiryPage";
import DayTripHoldPage from "../Pages/Dealers/DayTripHoldPage";

const googleId = "826763850002-fnamjgakaclbi20f1sbndsr8lp1noarp";

const App = () => {
	return (
		<GoogleOAuthProvider clientId={`${googleId}.apps.googleusercontent.com`}>
			<ThemeProvider theme={theme}>
				<AuthProvider authType={'localstorage'} authName={'user'}>
					<Router basename={window['appBasename']}>
						<ScrollToTop/>
						<Route path="/" exact component={AvailabilityPageNew}/>
						<Route path="/booking/dealer-integration" component={DealerAvailabilityPage} />
						<Route path="/iframe" exact component={DealerAvailabilityPage} />
						<Route path="/plugin" exact component={DealerAvailabilityPage} />
						<Route path="/booking/:id/select-room" component={SelectRoomPage}/>
						<Route path="/iframe/:id/select-room" component={SelectRoomPage}/>
						<Route path="/plugin/:id/select-room" component={SelectRoomPage}/>
						<Route path="/booking/:id/information" component={InformationPage}/>
						<Route path="/iframe/:id/information" component={InformationPage}/>
						<Route path="/plugin/:id/information" component={InformationPage}/>
						<Route path="/booking/hold/:bookingId" component={HoldPage}/>
						<Route path="/iframe/confirmation/:bookingId" component={HoldPage}/>
						<Route path="/plugin/confirmation/:bookingId" component={HoldPage}/>
						<Route path="/iframe/:id/review" component={ReviewPage} />
						<Route path="/plugin/:id/review" component={ReviewPage} />
						{/* Routes that are only available to logged-in users in the Dealer site version */}
						{isDealerSite() ?
							<CustomRoute path="/booking/:id/review" component={ReviewPage} /> :
							<Route path="/booking/:id/review" component={ReviewPage} />
						}
						{isDealerSite() ?
							<CustomRoute path="/booking/:id/activities" component={ActivitiesPage} /> :
							<Route path="/booking/:id/activities" component={ActivitiesPage} />
						}
						{isDealerSite() &&
							<CustomRoute
								path="/booking/charter/:shipCode"
								component={CharterPage}
								redirectAfterLogin
							/>
						}

						<CustomRoute path="/booking/:id/terms" component={TermsAndConditionsPage} />
						 <CustomRoute path="/booking/payment/:bookingId" component={PaymentPage}/>
						<CustomRoute path="/booking/payment-new/:bookingId" component={PaymentPageNew}/> {/* < Test new payment page */}
						<CustomRoute path="/booking/confirmation/:bookingId" component={ConfirmationPage} />

						<Route path="/booking/:id/wait-list" component={WaitListPage} />
						<Route path="/booking/:id/inquiry" component={InquiryPage} />
						<Route path="/plugin/:id/wait-list" component={WaitListPage} />
						<Route path="/plugin/:id/inquiry" component={InquiryPage} />
						<Route path="/booking/login" component={LoginPage} />
						<Route path="/booking/forgot_password" component={ForgotPasswordPage} />
						<Route path="/booking/reset_password/:token" component={ChangePasswordPage} />

						<Route path="/booking/upgrade/:id" component={UpgradeBookingPage} />
						<CustomRoute path="/booking/day-trips" exact component={DayTripListPage} />
						<CustomRoute path="/booking/day-trips/:activityId/book" component={DayTripBookingPage} />
						<CustomRoute path="/booking/day-trips/:activityId/inquiry" component={DayTripInquiryPage} />
						<CustomRoute path="/booking/day-trips/summary" exact component={DayTripReviewPage} />
						<CustomRoute path="/booking/day-trips/:bookingId/payment" exact component={DayTripsPaymentPage} />
						<CustomRoute path="/booking/day-trips/:bookingId/hold" exact component={DayTripHoldPage} />
						<CustomRoute path="/booking/day-trips/:bookingId/confirmation" exact component={DayTripConfirmationPage} />

						<CustomRoute path="/booking/my-bookings" exact component={MyBookingsPage} />
						{isDealerSite() && <CustomRoute path="/customization" exact component={BasicAuth} />}
						{isDealerSite() && <CustomRoute path="/ratings/my_ratings" exact component={BasicAuth} />}
						{isDealerSite() && <CustomRoute path="/account" exact component={BasicAuth} />}
						{isDealerSite() && <CustomRoute path="/contact" exact component={BasicAuth} />}
						{isDealerSite() && <CustomRoute path="/marketing/videos" exact component={BasicAuth} />}
						{isDealerSite() && <CustomRoute path="/marketing/images" exact component={BasicAuth} />}
						{isDealerSite() && <CustomRoute path="/marketing/downloads" exact component={BasicAuth} />}
						{isDealerSite() && <CustomRoute path="/auth/change_password" exact component={BasicAuth} />}
						{isDealerSite() &&
							<CustomRoute path="/booking/my-widget/get-apikey" exact component={GetWidgetApiKey} />
						}

						<CustomRoute path="/booking/my-bookings/:id" exact component={BookingPage} />
						<CustomRoute path="/booking/my-bookings/:id/payment" exact component={DashboardPaymentPage} />
						<CustomRoute path="/booking/my-bookings/:id/payment-new" exact component={DashboardPaymentPageNew} />
						<CustomRoute path="/booking/my-bookings/:id/select-accommodation" exact component={GuestAccommodationPage} />
						<CustomRoute path="/booking/my-bookings/:id/terms" exact component={DashboardTermsAndConditionsPage} />

						 <Route path="/booking/pay/:id" exact component={AnonymousPaymentPage}/>
						<Route path="/booking/pay-new/:id" exact component={AnonymousPaymentPageNew}/>
						<Route path="/booking/terms/:id" exact component={AnonymousTermsPage}/>

						<Route path="/booking/guest/:id/guest-form" component={GuestAccessPage} />
						<Route path="/booking/guest/:id/personal-information" component={PersonalInformationPage} />
						<Route path="/booking/guest/:id/medical-insurance" component={MedicalInsurancePage} />
						<Route path="/booking/guest/:id/diving" component={DivingPage} />
						<Route path="/booking/guest/:id/park-fees" component={ExtraPark} />
						<Route path="/booking/guest/:id/extra-activities" component={ExtraActivityPage} />
						<Route path="/booking/guest/:id/extra-order" component={ExtraActivityOrder} />


						{/*    Duplicated Routes    */}
						<Route path="/auth2/loginPageTest" component={LoginPageTest} />

						<CustomRoute path="/auth/payment" component={PaymentPage}/>
						<CustomRoute path="/auth/payment-new" component={PaymentPageNew}/>

						<Route path="/auth/login" component={LoginPage}/>
						<Route path="/auth/forgot_password" component={ForgotPasswordPage}/>
						<Route path="/auth/reset_password/:token" component={ChangePasswordPage}/>
						<Route path="/schedule/trip/:id" component={SelectRoomPage}/>
						<Route path="/schedule" exact component={AvailabilityPageNew}/>
						<Route path="/villas" component={AvailabilityPageNew}/>
						<Route path="/activities" component={AvailabilityPageNew}/>
						<Route path="/specials" component={AvailabilityPageNew}/>

						<Route path="/ratings" exact component={ListReviews} />
						<Route path="/ratings/destination/:name" component={ReviewsPage} />

					</Router>
				</AuthProvider>
			</ThemeProvider>
		</GoogleOAuthProvider>
	);
};

export default App;
